import { success, Type, Validation } from 'io-ts';

export const HtmlStrip = new Type<string, string, string>(
    'HtmlStrip',
    is,
    validate,
    encode,
);

function is(value: unknown): value is string {
    return true;
}

function validate(input: string): Validation<string> {
    return success(input.replace(/<[^>]*>?/gm, ''));
}

function encode(value: string): string {
    return value;
}
